var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#009B51"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3512 39.1212C21.8973 40.5751 21.8973 42.9322 23.3512 44.3861L33.881 54.9159C34.5794 55.6143 35.4862 55.9772 36.4011 56.0047C37.3976 56.0399 38.4055 55.6773 39.1662 54.9166L57.5934 36.4894C59.0473 35.0355 59.0473 32.6784 57.5934 31.2245C56.1395 29.7706 53.7823 29.7706 52.3285 31.2245L36.5239 47.029L28.6161 39.1212C27.1623 37.6673 24.8051 37.6673 23.3512 39.1212Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.cc955efe7445e29cf1d56ed956fcd60c.svg";
export { ForwardRef as ReactComponent };